import React from 'react';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import TpClientInvoiceJobLineMultiEditItem from '../../../../Domain/TpClientInvoiceJobLineMultiEditItem';
import TpClientInvoiceJobLineService from '../../../../Services/TpClientInvoiceJobLineService';

export default class EditMultipleTpClientInvoiceJobLinesWindowDescription extends React.Component {
  static titleForCreate = '';
  static titleForEdit = 'Edit Multiple Records';
  static itemType = TpClientInvoiceJobLineMultiEditItem;
  static serviceFunction = (edited) =>
    TpClientInvoiceJobLineService.MultipleEdit(
      edited,
      EditMultipleTpClientInvoiceJobLinesWindowDescription.getSearchParameters(),
      EditMultipleTpClientInvoiceJobLinesWindowDescription.getSelected(),
      EditMultipleTpClientInvoiceJobLinesWindowDescription.getAllItemsInTheSearchSetAreSelected()
    );

  static getSelected() {
    return null;
  }

  static getSearchParameters() {
    return null;
  }

  static getAllItemsInTheSearchSetAreSelected() {
    return null;
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'Client Billing',
      fields: [
        {
          fieldName: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.getClientCurrency(item),
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AdHocGroupEnabled',
          label: 'Modify Ad-Hoc Invoice Group?',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AdHocGroup',
          label: 'Ad-Hoc Invoice Group',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.AdHocGroupEnabled !== true,
        },
        {
          fieldName: 'ClientFee',
          label: 'Client Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'AdditionalClientFee',
          label: 'Additional Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'ClientTravel',
          label: 'Travel',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'ClientMisc',
          label: 'Misc',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'ClientReimbursement',
          label: 'Reimbursement',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableClientAmounts(item),
        },
        {
          fieldName: 'ClientGaming',
          label: 'Gaming',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableClientAmounts(item),
        },
      ],
    },
    // Its own section on purpose: the fieldwork fee is the one client-side amount held in a different
    // currency (the pricing currency), and sharing a page with the invoice-currency fields is exactly
    // how a figure typed in AED ended up stored as INR.
    {
      label: 'Fieldwork Fee',
      fields: [
        {
          fieldName: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.getFieldworkCurrency(item),
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'FieldworkFee',
          label: 'Fieldwork Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableFieldworkFee(item),
        },
      ],
    },
    {
      label: 'Evaluator Payment',
      fields: [
        {
          fieldName: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.getEvaluatorCurrency(item),
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'EvaluatorFee',
          label: 'Evaluator Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvaluatorTravel',
          label: 'Travel',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'AdditionalEvaluatorFee',
          label: 'Additional Fee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvaluatorMisc',
          label: 'Misc',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvaluatorReimbursement',
          label: 'Reimbursement',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableEvaluatorAmounts(item),
        },
        {
          fieldName: 'EvaluatorGaming',
          label: 'Gaming',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => EditMultipleTpClientInvoiceJobLinesWindowDescription.disableEvaluatorAmounts(item),
        },
      ],
    },
  ];

  // The Currency rows double as the explanation: when a field is disabled they say why, which is
  // clearer than removing it and leaving the user to guess where it went.
  //
  // Client amounts are typed in the invoice currency - the same one the grid shows - and the server
  // converts them into each job line's own storage currency on save where the two differ, so this is
  // always one code.
  static getClientCurrency(item) {
    if (item.ClientCurrencyCode) return `${item.ClientCurrencyCode} (the invoice currency, as shown in the list)`;
    return 'No invoice currency on the selected job(s) - client amounts cannot be edited';
  }

  static disableClientAmounts(item) {
    return !item.ClientCurrencyCode;
  }

  // The fieldwork fee is the exception: it is stored verbatim in the job's pricing currency - the one
  // the grid's FW Fee column shows - and is never converted, so it must be typed in that currency.
  // When the selection spans more than one pricing currency there is no single currency to type in,
  // so the field is disabled. The backend re-checks this across every affected job.
  static getFieldworkCurrency(item) {
    if (item.FwCurrencyCode) {
      // Spell out the difference only when there is one; when the two codes coincide the warning
      // would read as a contradiction of the row on the previous step.
      return item.FwCurrencyCode === item.ClientCurrencyCode
        ? `${item.FwCurrencyCode} (the pricing currency, as shown in the FW Fee column - the same as the invoice currency here)`
        : `${item.FwCurrencyCode} (the pricing currency, as shown in the FW Fee column - not the invoice currency ${item.ClientCurrencyCode})`;
    }
    if (item.FieldworkCurrencies && item.FieldworkCurrencies.length > 1) {
      return `Mixed (${item.FieldworkCurrencies.join(', ')}) - select one pricing currency to edit the fieldwork fee`;
    }
    return 'No pricing currency on the selected job(s) - the fieldwork fee cannot be edited';
  }

  static disableFieldworkFee(item) {
    return !item.FwCurrencyCode;
  }

  // Amounts entered here are stored verbatim against the evaluator payment - they are never
  // converted - so they must be typed in the payment's own currency. When the selection spans more
  // than one currency (or none of the selected jobs has a payment yet) there is no single currency
  // to type in, so the amount fields are disabled. The backend re-checks this across every affected
  // job, because a select-all only exposes the current page here.
  static getEvaluatorCurrency(item) {
    if (item.EvCurrencyCode) return item.EvCurrencyCode;
    if (item.EvaluatorCurrencies && item.EvaluatorCurrencies.length > 1) {
      return `Mixed (${item.EvaluatorCurrencies.join(', ')}) - select one currency to edit evaluator amounts`;
    }
    return 'No evaluator payment on the selected job(s) - evaluator amounts cannot be edited';
  }

  static disableEvaluatorAmounts(item) {
    return !item.EvCurrencyCode;
  }
}
